import { DeleteAsync, GetAsync, PostAsync, PutAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";
import { GenericApiResponse } from "src/@types/apis";
import { handleResponse } from "src/helpers/helpers";
import {
  ICreateDimensionValuePayload,
  IDimensionValuesListResponse,
  IGetDimensionValuesParams,
  IUpdateDimensionValuePayload,
} from "src/@types/dimension";
import { CATALOG_SERVICE_URL } from "src/constants/api";

const DIMENSION_VALUES_BASE = `${API_GATEWAY}/${CATALOG_SERVICE_URL}/DimensionValues`;

export const getDimensionValuesByDimensionId = async (
  params: IGetDimensionValuesParams,
): Promise<GenericApiResponse<IDimensionValuesListResponse>> => {
  const query = new URLSearchParams();
  query.append("DimensionId", params.dimensionId);
  query.append("Page", String(params.page));
  query.append("Record", String(params.record));
  if (params.name) query.append("Name", params.name);
  if (params.code) query.append("Code", params.code);
  if (params.value) query.append("Value", params.value);
  if (params.search) query.append("Search", params.search);

  const response = await GetAsync(
    `${DIMENSION_VALUES_BASE}/GetDimensionValuesByDimensionId?${query.toString()}`,
  );
  return handleResponse<IDimensionValuesListResponse>(response);
};

export const getDimensionValuesByDimensionName = async (
  dimensionName: string,
): Promise<GenericApiResponse<IDimensionValuesListResponse>> => {
  const query = new URLSearchParams();
  query.append("DimensionName", dimensionName);

  const response = await GetAsync(
    `${DIMENSION_VALUES_BASE}/GetDimensionValuesByDimensionName?${query.toString()}`,
  );
  return handleResponse<IDimensionValuesListResponse>(response);
};

export const createDimensionValue = async (
  payload: ICreateDimensionValuePayload,
): Promise<GenericApiResponse<any>> => {
  const response = await PostAsync(
    `${DIMENSION_VALUES_BASE}/CreateDimensionValue`,
    payload,
  );
  return handleResponse<any>(response);
};

export const updateDimensionValue = async (
  payload: IUpdateDimensionValuePayload,
): Promise<GenericApiResponse<any>> => {
  const response = await PutAsync(
    `${DIMENSION_VALUES_BASE}/UpdateDimensionValue`,
    payload,
  );
  return handleResponse<any>(response);
};

export const deleteDimensionValue = async (
  id: string,
): Promise<GenericApiResponse<any>> => {
  const response = await DeleteAsync(`${DIMENSION_VALUES_BASE}/${id}`);
  return handleResponse<any>(response);
};
